import { render } from "./ManualProductRecommendations.vue?vue&type=template&id=70337f0f"
import script from "./ManualProductRecommendations.vue?vue&type=script&lang=js"
export * from "./ManualProductRecommendations.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__